export default "__VITE_ASSET__BL3z7rkP__"